import React from 'react';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';

const researchTips = [
  "Recuerda siempre citar tus fuentes correctamente.",
  "Verifica que tu metodología sea reproducible.",
  "Un buen resumen puede abrir puertas.",
  "Tu marco teórico debe ser claro y actualizado.",
  "No subestimes la importancia de una buena presentación.",
  "Organiza tu cronograma y respétalo.",
  "Consulta a tus tutores con regularidad.",
  "Revisa el formato antes de enviar tu propuesta.",
  "Mantén un registro detallado de tus datos.",
  "Un objetivo bien planteado guía todo tu trabajo.",
];

const gifs = [
  "https://media1.giphy.com/media/v1.Y2lkPTc5MGI3NjExcTM4YXAyZHJvbjA3cTV3dDdhb2FuNGx1b2thbDI2d3NrY2gwanhrciZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/h6mBh5GMSfAvPec7Of/giphy.gif",
  "https://media4.giphy.com/media/v1.Y2lkPTc5MGI3NjExYjFuYWdncDR6ZGZjYm12aHI2Ym9hcWZ1ZXY5MXdibzIzNjl4eXZuZCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/7NS9RAepPQ0HJ85qJz/giphy.gif",
  "https://media2.giphy.com/media/v1.Y2lkPTc5MGI3NjExcXBsemlobW4zbWlzb29ycjJ1M2huMmZhNzlrd3ZkbXN0cWxxeml0OCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/L82o7jWh5Nd3qJg8d1/giphy.gif",
  "https://media4.giphy.com/media/v1.Y2lkPTc5MGI3NjExbWVjMW14cTJqeGttNG0xcmx3cmhtdTJpampib250Yzhlczl3eXpqaiZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/D8KpfyMWk53FK/giphy.gif",
  "https://media4.giphy.com/media/v1.Y2lkPTc5MGI3NjExa2NodmQzaHh5czNtOWtoZjk2cW5rdW9vdjhkaXZtZGwyYm13cWdwMyZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/5yccPytI1wapjfrq0V/giphy.gif",
  "https://media4.giphy.com/media/v1.Y2lkPTc5MGI3NjExOWc2MGk0djEzN2ZuZ2l3Z2o3cXJtbGdxemxuYnd6YWoxZmo0YTI5bSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/26BRC1tJ6qYOzG85a/giphy.gif",
  //"https://media.giphy.com/media/3oEduSbSGpGaRX2Vri/giphy.gif",
];

export const LoadingScreen: React.FC = () => {
  const tip = researchTips[Math.floor(Math.random() * researchTips.length)];
  const gif = gifs[Math.floor(Math.random() * gifs.length)];

  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'));
  const isMedium = useMediaQuery(theme.breakpoints.between('sm', 'md'));

  let imageSize = 200;
  if (isSmall) imageSize = 120;
  else if (isMedium) imageSize = 160;

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      padding={2}
      textAlign="center"
    >
      <img
        src={gif}
        alt="Cargando..."
        style={{ width: imageSize, maxWidth: '90%', height: 'auto', marginBottom: 20 }}
      />
      <Typography
        variant={isSmall ? 'body1' : 'h6'}
        sx={{ fontStyle: 'italic', color: '#555' }}
      >
        {tip}
      </Typography>
    </Box>
  );
};